/* Bundle Landingpage: Countdown, Galerie, Menge, Reveal, Direkt-Checkout */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('.bundle');
    if (!root) return;

    /* ---- Countdown (alle Instanzen synchron) ---- */
    var els = document.querySelectorAll('[data-countdown]');
    if (els.length) {
      var hours = parseInt(els[0].getAttribute('data-hours') || '4', 10);
      var key = 'shiatsu-deal-end';
      var end = parseInt(sessionStorage.getItem(key) || '0', 10);
      if (!end || end < Date.now()) {
        end = Date.now() + hours * 3600000 + 27 * 60000;
        sessionStorage.setItem(key, String(end));
      }
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var tick = function () {
        var d = Math.max(0, end - Date.now());
        var h = Math.floor(d / 3600000), m = Math.floor((d % 3600000) / 60000), s = Math.floor((d % 60000) / 1000);
        els.forEach(function (e) {
          var H = e.querySelector('[data-h]'), M = e.querySelector('[data-m]'), S = e.querySelector('[data-s]');
          if (H) H.textContent = pad(h);
          if (M) M.textContent = pad(m);
          if (S) S.textContent = pad(s);
        });
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---- Live-Viewer ---- */
    var vs = document.querySelectorAll('[data-viewers]');
    if (vs.length) {
      var v = 42;
      setInterval(function () {
        v = Math.max(24, Math.min(78, v + Math.round((Math.random() - 0.45) * 5)));
        vs.forEach(function (e) { e.textContent = String(v); });
      }, 6500);
    }

    /* ---- Galerie ---- */
    var main = document.getElementById('bMain');
    document.querySelectorAll('[data-bthumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (main) main.src = b.getAttribute('data-full');
        document.querySelectorAll('[data-bthumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    /* ---- Menge ---- */
    var qty = 1;
    var val = document.querySelector('[data-qval]');
    var setQty = function (n) { qty = Math.min(9, Math.max(1, n)); if (val) val.textContent = String(qty); };
    var minus = document.querySelector('[data-qminus]');
    var plus = document.querySelector('[data-qplus]');
    if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

    /* ---- Direkt-Checkout (kein Warenkorb-Umweg, kein neuer Tab) ---- */
    var variantId = (root.getAttribute('data-variant') || '').trim();
    var fallbackUrl = root.getAttribute('data-fallback') || '/collections/all';
    var busy = false;
    document.querySelectorAll('[data-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy) return;
        /* Kein Produkt verknüpft → auf die Produktseite schicken, statt nichts zu tun */
        if (!variantId) {
          (window.top || window).location.href = fallbackUrl;
          return;
        }
        busy = true;
        var label = btn.innerHTML;
        btn.innerHTML = 'Weiterleitung …';
        var done = false;
        var goCheckout = function () {
          if (done) return;
          done = true;
          (window.top || window).location.href = '/checkout';
        };
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
        })
          .then(function (r) {
            if (!r.ok) {
              /* z. B. ausverkauft → Warenkorb-/Produktseite zeigen */
              done = true;
              (window.top || window).location.href = fallbackUrl;
              return;
            }
            goCheckout();
          })
          .catch(function () {
            busy = false;
            btn.innerHTML = label;
          });
        setTimeout(goCheckout, 2500);
      });
    });

    /* ---- Scroll-Reveal ---- */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '-8% 0px -8% 0px' });
    document.querySelectorAll('.bundle .reveal').forEach(function (e, i) {
      e.style.transitionDelay = (i % 3) * 90 + 'ms';
      io.observe(e);
    });
  });
})();
